module.exports = __webpack_public_path__ + "static/media/china.d87104c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/china.svg
// module id = 375
// module chunks = 1